import React, { useEffect, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';

// ปุ่มติดตั้งแอป (PWA) ลอยมุมขวาบนเสมอ — โผล่เฉพาะตอนเบราว์เซอร์ยิง `beforeinstallprompt`
// (รองรับแค่ตระกูล Chromium: Chrome/Edge — Firefox/Safari ไม่มี event นี้เลยปุ่มจะไม่โผล่)
export default function InstallAppButton() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    const handleAppInstalled = () => setDeferredPrompt(null);
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  if (!deferredPrompt) return null;

  const handleClick = async () => {
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
  };

  return (
    <Tooltip title="Only For Chrome" placement="bottom-end" arrow>
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{
          position: 'fixed',
          top: 8,
          right: 8,
          zIndex: 9999,
          width: 28,
          height: 28,
          backgroundColor: 'rgba(179, 52, 52, 0.9)',
          color: '#fff',
          boxShadow: '0 2px 8px rgba(0,0,0,0.35)',
          '&:hover': { backgroundColor: 'rgba(179, 52, 52, 1)' },
        }}
      >
        <GetAppIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  );
}
